<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ 'Confirm delete' | t }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" [attr.aria-label]="'Close' | t"></button>
    </div>
    <div class="modal-body">
      {{ 'Are you sure you want to delete “{item}”?' | t: {item: deleteWhat} }}
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ 'Cancel' | t }}</button>
      <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="confirm.emit()">{{ 'Confirm' | t }}</button>
    </div>
  </div>
</div>


